module.exports = {
  "videoUsage": {
    "name": "video-usage",
    "class": "usage",
    "properties": {
      "type": [
        "rendered",
        "loaded",
        "started",
        "engaged",
        "finished",
        "minutes-watched"
      ],
      "playerType": "string",
      "videoId": "string",
      "viewDuration": {
        "type": "number",
        "isOptional": true
      },
      "autoPlay": {
        "type": "boolean",
        "isOptional": true
      },
      "creatorHubId": {
        "type": "number",
        "isOptional": true
      },
      "contentId": {
        "type": "string",
        "isOptional": true
      },
      "renderContext": {
        "type": "string",
        "isOptional": true
      },
      "sourceUrl": {
        "type": "string",
        "isOptional": true
      },
      "videoType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "embedded-academy-ui",
    "version": "1"
  },
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subScreen": {
        "type": "string",
        "isOptional": true
      },
      "hostAppName": {
        "type": "string",
        "isOptional": true
      },
      "results": {
        "type": "boolean",
        "isOptional": true
      },
      "strategy": {
        "type": "string",
        "isOptional": true
      },
      "query": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "embedded-academy-ui",
    "version": "1"
  },
  "interaction": {
    "name": "interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "screen": {
        "type": "string",
        "isOptional": true
      },
      "hostAppName": {
        "type": "string",
        "isOptional": true
      },
      "contentId": {
        "type": "number",
        "isOptional": true
      },
      "lessonId": {
        "type": "number",
        "isOptional": true
      },
      "shortId": {
        "type": "number",
        "isOptional": true
      },
      "isTimestamped": {
        "type": "boolean",
        "isOptional": true
      },
      "strategy": {
        "type": "string",
        "isOptional": true
      },
      "feedback": {
        "type": "string",
        "isOptional": true
      },
      "query": {
        "type": "string",
        "isOptional": true
      },
      "id": {
        "type": "number",
        "isOptional": true
      },
      "type": {
        "type": "string",
        "isOptional": true
      },
      "language": {
        "type": "string",
        "isOptional": true
      },
      "name": {
        "type": "string",
        "isOptional": true
      },
      "cardNumber": {
        "type": "number",
        "isOptional": true
      },
      "recommendationType": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "embedded-academy-ui",
    "version": "1"
  }
};